import React, { useState } from 'react';
import './LoginPage.css'; // Reuse styles

function AdminLogin({ onLogin, onBack }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();
    // Simple password check
    // In production, this should be an environment variable
    const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD || 'admin123';
    
    if (password === adminPassword) {
      onLogin();
    } else {
      setError('Mật khẩu không đúng');
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <h1>Quản Trị Viên</h1>
          <p>Vui lòng nhập mật khẩu quản trị</p>
        </div>

        <form onSubmit={handleLogin} className="login-form">
          <div className="form-group">
            <input
              type="password"
              placeholder="Mật khẩu"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoFocus
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="btn-login">
            Đăng Nhập
          </button>
        </form>

        <div className="login-footer">
          <button onClick={onBack} className="btn-admin-link">
            ← Quay lại trang chấm công
          </button>
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;
